import { type Genre } from "@ca.vmedia.tv/domains";

export class GenresSubitemsRequest {
    constructor(
        readonly genre: Genre,
        readonly itemsPerPage: number,
        readonly pageNumber: number
    ) {}
}